module.exports = __webpack_public_path__ + "static/media/maria.3dcea0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/maria.png
// module id = 1649
// module chunks = 0